import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const FilePlist = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H16C17.1046 22 18 21.1046 18 20V17H16V20H4V4H16V7H18V4C18 2.89543 17.1046 2 16 2H4Z"
      fill="currentColor"
    />
    <path
      d="M16.3896 12.052C16.7358 12.1613 17.0167 12.2499 17.0167 12.4639C17.0167 12.6986 16.8112 12.904 16.4884 12.904C15.9602 12.904 15.6081 12.4639 15.6081 12.4639L14.9625 13.1388C14.9625 13.1388 15.52 13.8431 16.6058 13.8431C17.6329 13.8431 18.2492 13.2268 18.2492 12.4932C18.2492 11.6071 17.5248 11.3785 16.9688 11.203C16.6226 11.0938 16.3417 11.0051 16.3417 10.7912C16.3417 10.6151 16.5178 10.439 16.7819 10.439C17.1869 10.439 17.4568 10.7618 17.4568 10.7618L18.1024 10.0869C18.1024 10.0869 17.6622 9.5 16.6645 9.5C15.7255 9.5 15.1092 10.1162 15.1092 10.7618C15.1092 11.648 15.8336 11.8766 16.3896 12.052Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.34875 9.61738H5.5V13.7257H6.61512V12.4932H7.34875C8.25845 12.4932 8.8747 11.877 8.8747 11.0553C8.8747 10.2336 8.25845 9.61738 7.34875 9.61738ZM6.61512 10.6151H7.29006C7.55416 10.6151 7.75958 10.8205 7.75958 11.0553C7.75958 11.2901 7.55416 11.4955 7.29006 11.4955H6.61512V10.6151Z"
      fill="currentColor"
    />
    <path d="M9.63234 13.7257H12.5669V12.728H10.7475V9.61738H9.63234V13.7257Z" fill="currentColor" />
    <path d="M13.2071 13.7257V9.61738H14.3222V13.7257H13.2071Z" fill="currentColor" />
    <path d="M18.596 9.61738H22V10.6151H20.8555V13.7257H19.7404V10.6151H18.596V9.61738Z" fill="currentColor" />
  </Icon>
));

export default FilePlist;
